export default "/assets/images/two-size-mila.png?3509d0fc7a50ce4652cd2d6b430c12b4";